import { SubmissionError } from '#helper/submission-error';
import { fetchAdditions, snackBarError } from '#action/fetch';
import { FETCH_SHIPMENT_GOODS, FETCH_SHIPMENT_CONTAINERS, FETCH_SHIPMENT_CARGO } from '#action/types';
import { webPortalApi } from '#config/web-portal-api';
import { getRequestOptions } from '#helper';

export const fetchShipmentGoods = () =>
  dispatch =>
    dispatch(fetchAdditions('shipment/goods', FETCH_SHIPMENT_GOODS));

export const fetchShipmentContainers = () =>
  dispatch =>
    dispatch(fetchAdditions('shipment/containers', FETCH_SHIPMENT_CONTAINERS));

export const fetchShipmentCargo = id =>
  dispatch =>
    dispatch(fetchAdditions(`shipment/${id}/cargo`, FETCH_SHIPMENT_CARGO));

export const fetchCargo = id =>
  dispatch =>
    Promise.all([
      dispatch(fetchShipmentGoods()),
      dispatch(fetchShipmentContainers()),
      dispatch(fetchShipmentCargo(id))
    ]);

export const postCargo = (id, cargo) => async dispatch => {
  const res = await fetch(webPortalApi.buildApiUrl(`shipment/${id}/cargo`), {
    method: 'POST',
    body: JSON.stringify(cargo),
    ...getRequestOptions()
  });
  const response = await res.json();

  if (!res.ok) {
    dispatch(
      snackBarError({
        message: 'Error in request',
        ...response
      })
    );
    throw new SubmissionError(response);
  }

  return { success: true };
};

export const editCargo = (id, cargo) => async dispatch => {
  const res = await fetch(webPortalApi.buildApiUrl(`shipment/${id}/cargo`), {
    method: 'PUT',
    body: JSON.stringify(cargo),
    ...getRequestOptions()
  });
  const response = await res.json();

  if (!res.ok) {
    dispatch(
      snackBarError({
        message: 'Error in request',
        ...response
      })
    );
    throw new SubmissionError(response);
  }

  return { success: true };
};
